import HttpRequest from './http_request'

class QuestionnaireProvider extends HttpRequest {
  constructor() {
    // api api
    super(process.env.VUE_APP_ENDPOINT)
  }

async getQuestionnaire() {
    const { data } = await this.get('admission/api/', {
      function: 'get-user-review',
    })
    return data
  }

  async setQuestionnaire(info) {
    const { data } = await this.update('admission/api/', {
      function: 'set-user-review',
      PROVINCE_ID: info.PROVINCE_ID,
      DEVICE: info.DEVICE,
      NEWS: info.NEWS,
      NEWS_OTHER: info.NEWS_OTHER,
      INTERNET: info.INTERNET,
      INTERNET_OTHER: info.INTERNET_OTHER,
      Q1_1: info.Q1_1,
      Q1_2: info.Q1_2,
      Q1_3: info.Q1_3,
      Q1_4: info.Q1_4,
      Q1_5: info.Q1_5,
      Q2_1: info.Q2_1,
      Q2_2: info.Q2_2,
      Q2_3: info.Q2_3,
      Q2_4: info.Q2_4,
      Q3_1: info.Q3_1,
      Q3_2: info.Q3_2,
      Q3_3: info.Q3_3,
      Q3_4: info.Q3_4,
      ADD_1: info.ADD_1,
      ADD_2: info.ADD_2,
      ADD_3: info.ADD_3,
    })
    return data
  }
}

export default QuestionnaireProvider